/**
 * Dm input component
 */
import {
  Component,
  Input,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { I18n } from '@app/i18n/strings-keys';
import { Observable } from '@shared/rx';
import { ToolbarButtonDefinition } from '@shared/types';
import { asObservable } from '@shared/utils';

export interface ComponentStaticText {
  [key: string]: any;
}

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-input',
  templateUrl: 'input.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class XVIInputComponent implements OnChanges {
  @Input() public label: string;
  @Input() public name: string = '';
  @Input() public class: string = '';
  @Input() public placeholder: string = '';
  @Input() public control: FormControl = new FormControl();
  @Input() public id: string;
  @Input() public disabled: boolean;
  @Input() public required: boolean;
  @Input() public type: string = 'text';
  @Input() public min: number;
  @Input() public max: number;
  @Input() public readonly: boolean;
  @Input() public addonButton: ToolbarButtonDefinition;
  @Input() public description: string;

  @Input() public set backgroundColor(value) {
    this.backgroundColorObs = asObservable(value);
  }
  @Input() public set textColor(value) {
    this.textColorObs = asObservable(value);
  }
  public backgroundColorObs: Observable<string>;
  public textColorObs: Observable<string>;
  public staticTextContent: ComponentStaticText = {
    loading: I18n.Common.Loading,
  };
  public addonButtonClickActionHandle(
    addonButton: ToolbarButtonDefinition,
  ): any {
    if (addonButton.click) addonButton.click();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public ngOnChanges(changes: SimpleChanges): void {
    // a fallback for a case when the field has no control (the field is absent in the API schema)
    if (!this.control) {
      this.control = new FormControl();
    }
  }

  public setControlValue(value): void {
    this.control.markAsDirty();
    this.control.markAsTouched();
    this.control.setValue(value);
  }
}
